import bridge from 'bridge'
import fetch from 'fetch'
import consts from 'consts'
import store from 'store2'
import logger from 'logger'
import cookie from 'cookie'

const loginCodeWithUA = (ua) => {
	return fetch({
		method: 'post',
		url: '/v1/user/loginCode',
		data: {
			'ua': ua
		}
	})
}

const sendCodeWithUA = (ua) => {
	return fetch({
		method: 'post',
		url: '/v1/user/sendCode',
		data: {
			'ua': ua
		}
	})
}

const get = () => {
	return new Promise((resolve, reject) => {
		fetch({
			url: '/v1/user'
		}).on('success', function (user) {
			store.set('user', JSON.stringify(user))
			resolve(user)
		}).on('error', function (err) {
			reject(err)
		})
	})
}

const login = (data) => {
	logger.sendEvent('点击', '登录')
	return new Promise((resolve, reject) => {
		data.ct = consts.clientType
		fetch({
			method: 'post',
			url: '/v1/user/login',
			data: data
		}).then((data) => {
			if (!data.needCaptcha) {
				bridge.setUser(data)
				data.user.newUser = data.newUser
				data.user.couponAmount = data.couponAmount
				store.set('user', JSON.stringify(data.user))
				cookie.set('token', data.token, 24 * 365, '.piaoniu.com', '/')
				const sensors = require('sensors')
				sensors.login(data.user.userId)
				resolve(data.user)
			} else {
				resolve(data)
			}
		}).catch(reject)
	})
}

const register = (data) => {
	logger.sendEvent('点击', '注册')
	return new Promise((resolve, reject) => {
		data.ct = consts.clientType
		fetch({
			method: 'post',
			url: '/v1/user/reg',
			data: data
		}).then((data) => {
			bridge.setUser(data)
			store.set('user', JSON.stringify(data.user))
			const sensors = require('sensors')
			sensors.login(data.user.userId)
			resolve(data.user)
		}).catch(reject)
	})
}

export default {
	get,
	login,
	register,
	loginCodeWithUA,
	sendCodeWithUA
}



// WEBPACK FOOTER //
// ./src/mods/service/user.js